import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { Card } from "reactstrap";
import { theme } from "../../constants/theme";
import {
  BLUE_BACKGROUND_COLOR,
  CARD_TITLE_COLOR,
  PRICE_DISPLAY_RED,
  WHITE,
} from "../../constants/colors";


const CardForm = styled(Card)`
  background-color: ${theme.color.surface};
  border: 1px solid ${theme.color.border};
  border-radius: ${theme.radius.lg};
  padding: 2rem;
  color: ${theme.color.text};
  box-shadow: ${theme.shadow.md};

  label {
    margin-top: 0.75rem;
    font-weight: ${theme.weight.medium};
    color: ${theme.color.slate};
    font-size: ${theme.type.sm};
    letter-spacing: 0.01em;
  }

  .title {
    margin-top: 0.5rem;
  }

  .card-title {
    color: ${CARD_TITLE_COLOR};
    font-family: ${theme.font.display};
    font-weight: ${theme.weight.semibold};
    font-size: ${theme.type.xl};
    text-align: center;
    margin-bottom: 1.25rem;
    letter-spacing: -0.02em;
  }

  .btn {
    margin-top: 1.375rem;
    background-color: ${BLUE_BACKGROUND_COLOR};
    border-color: ${BLUE_BACKGROUND_COLOR};
    color: ${WHITE};
    font-weight: ${theme.weight.semibold};
    border-radius: ${theme.radius.md};
    padding: 0.75rem 1.5rem;
    box-shadow: ${theme.shadow.sm};
    transition: transform ${theme.motion.quick},
      box-shadow ${theme.motion.base},
      background-color ${theme.motion.base};

    &:hover {
      background-color: ${theme.color.slateDeep};
      border-color: ${theme.color.slateDeep};
      box-shadow: ${theme.shadow.md};
      transform: translateY(-1px);
    }

    &:active {
      transform: translateY(0);
    }
  }

  .input-group-text {
    background-color: ${theme.color.surfaceSunk};
    border: 1px solid ${theme.color.border};
    border-radius: ${theme.radius.md};
    color: ${theme.color.textMuted};
    font-weight: ${theme.weight.medium};
  }

  .input-group {
    margin-bottom: 0.75rem;
  }
`;

const FormCard = ({ children }) => <CardForm className="no-transition">{children}</CardForm>;

export const FormError = styled.label`
  text-align: left;
  color: ${PRICE_DISPLAY_RED};
  display: block;
  font-weight: ${({ fontWeight }) => fontWeight};
  font-size: ${theme.type.sm};
  margin-top: 0.35rem;
`;

FormCard.propTypes = {
  children: PropTypes.node,
  buttonText: PropTypes.string,
  bgNumber: PropTypes.object,
  title: PropTypes.string,
};

export default FormCard;
